// BEFORE / AFTER of an audited action: removed lines in alert, added in success.

import clsx from "clsx";
import type { AdminAuditEntry } from "@paceroo/domain/views/admin";
import s from "../screens/Runner.module.css";

const show = (v: unknown) => (v === undefined || v === null ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

export function AuditDiff({ entry }: { entry: AdminAuditEntry }) {
  const keys = [...new Set([...Object.keys(entry.before ?? {}), ...Object.keys(entry.after ?? {})])];
  return (
    <div className={s.diff}>
      <span className={clsx("t-mono-xs ink-mute", s.diffHead)}>BEFORE</span>
      <span className={clsx("t-mono-xs ink-mute", s.diffHead, s.diffRight)}>AFTER</span>
      {keys.map((k) => (
        <div key={k} style={{ display: "contents" }}>
          <span className={clsx("t-mono-xs", s.diffCell)} style={{ color: "var(--alert)" }}>
            − {k}: {show(entry.before?.[k])}
          </span>
          <span className={clsx("t-mono-xs", s.diffCell, s.diffRight)} style={{ color: "var(--success)" }}>
            + {k}: {show(entry.after?.[k])}
          </span>
        </div>
      ))}
      {keys.length === 0 && <span className={clsx("t-mono-xs ink-mute", s.diffCell)}>No recorded change.</span>}
    </div>
  );
}
